import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Flex, Heading, Text } from '@chakra-ui/react'

import { Item } from 'appTypes/mapper'
import { ButtonText, ButtonWhite } from 'components/ui/Buttons/Button'
import { CardSimple } from 'components/ui/Card/CardSimple'
import { getImageUrl } from 'utils/getProductImageUrl'
import { normalizeUrl } from 'utils/normalizeUrl'

import { FeaturedBundleItems, StyledCard } from './styles'

type Props = {
  bundle: Item
}

export const FeaturedBundle: React.FC<Props> = ({ bundle }) => {
  const { t } = useTranslation('common')

  return (
    <StyledCard>
      <Flex justifyContent="space-between">
        <Flex width="40%" direction="column" justifyContent="space-between">
          <Box>
            <Heading as="h3" fontSize="lg" fontWeight="400" lineHeight={{ base: 1.33, md: 1.2 }}>
              {bundle.name}
            </Heading>
            <Text fontSize="sm" marginTop="8px" fontWeight="300">
              {bundle.description}
            </Text>
            <Text fontSize="md" marginTop="8px">
              {bundle.pricePerDay ?? '-'} {t('nokPerDay')}
            </Text>
            {bundle.discount && (
              <Text color="green.a200" fontSize="sm">
                {t('youSaveUpTo')} {bundle.discount}%
              </Text>
            )}
          </Box>
          <Flex display={{ base: 'none', md: 'flex' }} alignItems="center" marginTop={{ lg: '30px' }}>
            <Box width="183px" marginRight="50px">
              <ButtonWhite href="/bundles/[name]" as={`/bundles/${normalizeUrl(bundle.name, bundle.id)}`}>
                {t('rentIt')}
              </ButtonWhite>
            </Box>
            <ButtonText isLight href="/bundles">
              {t('seeAllBundles')}
            </ButtonText>
          </Flex>
        </Flex>
        <FeaturedBundleItems>
          {bundle?.products.map((product) => (
            <CardSimple key={product.id} name={product.name} imageUrl={getImageUrl(product.images ?? [])} />
          ))}
        </FeaturedBundleItems>
      </Flex>
    </StyledCard>
  )
}
